(function(){
  "use strict";

  /* Catálogo real da loja, injetado pelo Liquid em window.HG_CAT.
     Rendimento (im/po) = aves x dias que a embalagem cobre no preventivo,
     calculado a partir da bula. Editar no template page.oferta.liquid. */
  var CAT = window.HG_CAT || [];

  /* R$ 1.446,00 — separador de milhar, como o brasileiro lê */
  var brl = function(v){
    var p = v.toFixed(2).split(".");
    return "R$ " + p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".") + "," + p[1];
  };
  var url = function(it){ return (window.HG_CART || "/cart") + "/" + it.vid + ":1"; };
  var $   = function(id){ return document.getElementById(id); };

  /* =========================================================
     2. CONTADOR DA OFERTA SEMANAL
        Fecha no domingo 23:59:59 e reinicia sozinho na segunda.
        Só é honesto se as ofertas realmente girarem toda semana.
     ========================================================= */
  function tick(){
    var now = new Date();
    var end = new Date(now);
    end.setDate(now.getDate() + ((7 - now.getDay()) % 7));
    end.setHours(23, 59, 59, 999);
    var s = Math.max(0, Math.floor((end - now) / 1000));
    var d = Math.floor(s / 86400), h = Math.floor(s % 86400 / 3600),
        m = Math.floor(s % 3600 / 60), sec = s % 60;
    var pad = function(v){ return String(v).padStart(2, "0"); };
    var txt = (d > 0 ? d + "d " : "") + pad(h) + ":" + pad(m) + ":" + pad(sec);
    ["clock", "clock2"].forEach(function(id){ var el = $(id); if (el) el.textContent = txt; });
  }
  tick();
  setInterval(tick, 1000);

  /* =========================================================
     3. CATÁLOGO
     ========================================================= */
  function coverage(it){
    var o = [];
    if (it.im > 0) o.push("<b>" + Math.round(it.im / 30) + "</b> aves/mês · imunidade");
    if (it.po > 0) o.push("<b>" + Math.round(it.po / 30) + "</b> galinhas/mês · postura");
    return o.join("<br>");
  }
  function perAveOf(it){ return it.p / (Math.max(it.im, it.po) / 30); }

  function buildLadder(){
    var el = $("ladder"); if (!el || !CAT.length) return;
    var best = CAT.reduce(function(a, b){ return perAveOf(b) < perAveOf(a) ? b : a; });
    el.innerHTML = CAT.map(function(it){
      var off = it.was > it.p ? Math.round((1 - it.p / it.was) * 100) : 0;
      return '<article class="sku' + (it === best ? ' sku--best' : '') + '">'
        + (it === best ? '<span class="sku-flag">Melhor custo por ave</span>' : '')
        + (it.img ? '<img class="sku-photo" src="' + it.img + '" alt="' + it.n + '" loading="lazy" width="480" height="300">' : '')
        + '<span class="sku-line">' + it.line + '</span>'
        + '<h4>' + it.n + '</h4>'
        + '<div class="sku-cov">' + coverage(it) + '</div>'
        + '<div class="sku-price"><span class="p-now">' + brl(it.p) + '</span>'
        + (off ? '<span class="p-was">' + brl(it.was) + '</span><span class="p-off">-' + off + '%</span>' : '')
        + '</div>'
        + '<div class="p-unit">' + brl(perAveOf(it)) + ' por ave/mês · frete grátis</div>'
        + '<a class="btn btn-primary btn-block" href="' + url(it) + '">Comprar</a>'
        + '</article>';
    }).join("");
  }

  /* =========================================================
     4. CALCULADORA
        Ordena por custo por ave/mês (o que o avicultor compara),
        descartando estoque acima de 12 meses.
     ========================================================= */
  function need(){
    var v = parseInt($("aves").value, 10);
    if (!v || v < 1) v = 1;
    if (v > 50000) v = 50000;
    var sel = document.querySelector('input[name="obj"]:checked');
    return { aves: v, obj: sel ? sel.value : "imuno" };
  }
  function rank(req){
    var demand = req.aves * 30;
    var wantIm = req.obj === "imuno" || req.obj === "ambos";
    var wantPo = req.obj === "ovo"   || req.obj === "ambos";
    var out = [];
    CAT.forEach(function(it){
      for (var q = 1; q <= 6; q++){
        if (wantIm && it.im * q < demand) continue;
        if (wantPo && it.po * q < demand) continue;
        var months = Math.min(
          wantIm ? (it.im * q) / demand : Infinity,
          wantPo ? (it.po * q) / demand : Infinity
        );
        out.push({ it: it, q: q, total: it.p * q, months: months, perAve: (it.p * q) / (req.aves * months) });
        break;
      }
    });
    var sane = out.filter(function(o){ return o.months <= 12; });
    if (!sane.length) sane = out;
    sane.sort(function(a, b){ return a.perAve - b.perAve || a.total - b.total; });
    return sane;
  }
  function render(){
    var req = need(), list = rank(req), box = $("saida");
    if (!list.length){
      box.innerHTML = '<p class="small" style="margin:0">Plantel acima do que esta página atende. '
        + '<a href="/pages/contact">Fale com a gente</a> para um orçamento de granja.</p>';
      return;
    }
    var top = list[0];
    var cheapest = list.reduce(function(a, b){ return b.total < a.total ? b : a; });
    var alts = [];
    if (cheapest !== top) alts.push({ o: cheapest, why: "Menor investimento inicial" });
    for (var i = 1; i < list.length && alts.length < 2; i++){
      if (list[i] !== cheapest) alts.push({ o: list[i], why: "Rende " + list[i].months.toFixed(1).replace(".", ",") + " meses" });
    }

    box.innerHTML =
      '<span class="rec-tag">Recomendado para ' + req.aves + ' aves</span>'
      + '<div class="rec-name">' + (top.q > 1 ? top.q + '× ' : '') + top.it.n + '</div>'
      + '<div class="rec-figs">'
      +   '<div><span class="fig-v">' + brl(top.total) + '</span><span class="fig-l">Total</span></div>'
      +   '<div><span class="fig-v">' + top.months.toFixed(1).replace(".", ",") + '</span><span class="fig-l">Meses de uso</span></div>'
      +   '<div><span class="fig-v">' + brl(top.perAve) + '</span><span class="fig-l">Por ave/mês</span></div>'
      + '</div>'
      + '<a class="btn btn-primary btn-block btn-lg" href="' + url(top.it) + '">Comprar — frete grátis</a>'
      + (alts.length
          ? '<div class="alts">' + alts.map(function(a){
              return '<a class="alt" href="' + url(a.o.it) + '"><span>'
                + (a.o.q > 1 ? a.o.q + '× ' : '') + a.o.it.n
                + '<br><span class="tiny">' + a.why + '</span></span><b>' + brl(a.o.total) + '</b></a>';
            }).join("") + '</div>'
          : '');

    $("dockPrice").textContent = brl(top.total);
    $("dockName").textContent  = (top.q > 1 ? top.q + '× ' : '') + top.it.n + " · frete grátis";
    $("dockLink").href         = url(top.it);
  }

  /* =========================================================
     5. BARRA DE COMPRA — aparece depois que o hero sai da tela
     ========================================================= */
  var dock = $("dock"), hero = $("topo");
  if (dock && hero && "IntersectionObserver" in window){
    new IntersectionObserver(function(e){
      dock.classList.toggle("on", !e[0].isIntersecting);
      document.body.style.paddingBottom = e[0].isIntersecting ? "0px" : "78px";
    }, { threshold: 0 }).observe(hero);
  }

  buildLadder();
  render();
  $("aves").addEventListener("input", render);
  Array.prototype.forEach.call(document.querySelectorAll('input[name="obj"]'), function(r){
    r.addEventListener("change", render);
  });
})();
